import CustomTooltip from "@/components/tooltip/tooltip"
import { Button } from "antd"
import facebookUsernameIllustration from './assets/facebook-get-username.svg'
import facebookGetUrlIllustration1 from './assets/facebook-get-post-url-1.svg'
import facebookGetUrlIllustration2 from './assets/facebook-get-post-url-2.svg'
import facebookPrivacyConfigIllustration from './assets/facebook-privacy-config.svg'
import facebookPrivateProfileIllustration from './assets/facebook-private-profile.svg'

const getFacebookUsernameTooltip = [
  {
    illustration: <img src={facebookUsernameIllustration} alt="Ilustración obtener nombre de usuario de Facebook" />,
    message: <p>Ve a tu perfil en un navegador y copia el usuario de la barra de direcciones.</p>
  },
]

const getFacebookpostUrlTooltip = [
  {
    illustration: <img src={facebookGetUrlIllustration1} alt="Ilustración obtener enlace de publicación" />,
    message: <p>Dirígete a tu publicación y presiona <b>“Compartir”</b>.</p>
  },
  {
    illustration: <img src={facebookGetUrlIllustration2} alt="Ilustración obtener enlace de publicación" />,
    message: <p>En la sección “Compartir en”, <b>selecciona la opción “Copiar enlace”</b>.</p>
  },
]

const privateFacebookProfile = [
  {
    illustration: <img src={facebookPrivateProfileIllustration} alt="Ilustración configuración de privacidad de Facebook" />,
    message: <p>Si tu perfil es privado o está restringido, no podremos verlo.</p>
  },
  {
    illustration: <img src={facebookPrivacyConfigIllustration} alt="Ilustración configuración de privacidad de Facebook" />,
    message: <p>Verifica la configuración de privacidad de tu perfil para asegurarte de que no tenga restricciones.</p>
  },
]

const FacebookHelpToolTips = () => {
  return (
    <>
      <CustomTooltip items={getFacebookUsernameTooltip}>
        <Button style={{ alignSelf: "flex-end" }}>Obtener mi usuario de Facebook</Button>
      </CustomTooltip>
      <CustomTooltip items={getFacebookpostUrlTooltip}>
        <Button style={{ alignSelf: "flex-end" }}>Obtener enlace de publicación</Button>
      </CustomTooltip>
      <CustomTooltip items={privateFacebookProfile}>
        <Button style={{ alignSelf: "flex-end" }}>Verificaca que tu perfil sea visible</Button>
      </CustomTooltip>
    </>
  )
}

export default FacebookHelpToolTips;